import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Page, Spinner } from "@cc/react-components";

interface Props extends React.HTMLAttributes<HTMLElement> {
  inView: boolean;
  onInView: () => void;
  isValid: boolean;
}

const MedicationDone = ({ inView, onInView, isValid }: Props) => {
  const [t] = useTranslation();

  useEffect(() => {
    inView && isValid && onInView();
  }, [inView, onInView, isValid]);

  return (
    <Page>
      <Page.Body>
        <div className="h-100 d-flex flex-column align-items-center justify-content-center">
          {isValid && (
            <>
              <div className="p-2">
                <Spinner animation="brand" />
              </div>
              <p className="text-muted">{t("medicationFlow.continue")}</p>
            </>
          )}
          {!isValid && (
            <Alert variant="danger">{t("medicationFlow.continueError")}</Alert>
          )}
        </div>
      </Page.Body>
    </Page>
  );
};

export default MedicationDone;
